import { Component, input } from '@angular/core';
import { FiltersSectionHeadingComponent } from '../filters-section-heading/filters-section-heading.component';

@Component({
  selector: 'pwj-filters-section',
  standalone: true,
  imports: [FiltersSectionHeadingComponent],
  templateUrl: './filters-section.component.html',
  styleUrl: './filters-section.component.scss',
})
export class FiltersSectionComponent {
  showDivider = input(false);
  titleKey = input<string>();
  icon = input<string>();
}
